import { RouteRecordRaw } from "vue-router";

const testResultRoutes: RouteRecordRaw[] = [
  {
    path: "/test-results/student/:subject/:kind",
    component: () => import("../views/test-results/TRListView.vue"),
    props: { target: "student" },
  },
  {
    path: "/test-results/student/:studentId/:subject/:kind",
    component: () => import("../views/test-results/TRListView.vue"),
    props: { target: "student" },
  },
  {
    path: "/test-results/test/:subject/:testId/:classId?",
    component: () => import("../views/test-results/TRListView.vue"),
    props: { target: "test" },
  },
];

export default testResultRoutes;
